(function () {
  const drawer = document.querySelector('.catDrawer');
  if (!drawer) return;

  const openBtns = document.querySelectorAll('[data-open-categories]');
  const closeBtn = drawer.querySelector('.catDrawer__close');
  const l1Buttons = drawer.querySelectorAll('.catL1__btn');
  const panels = drawer.querySelectorAll('.catPanel');

  // ✅ MISMO breakpoint que el CSS
  const DESKTOP_MQ = window.matchMedia('(min-width: 1200px)');
  const isDesktop = () => DESKTOP_MQ.matches;

  function activate(btn) {
    const id = btn.getAttribute('data-cat-target');
    if (!id) return;

    l1Buttons.forEach(b => {
      const on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });

    panels.forEach(p => {
      p.hidden = (p.id !== id);
    });
  }

  function setInitialActive() {
    // deja el primero como “activo” para la próxima apertura
    const firstBtn = l1Buttons[0];
    const firstPanel = panels[0];

    panels.forEach((p, i) => (p.hidden = i !== 0));
    l1Buttons.forEach((b, i) => {
      b.classList.toggle('is-active', i === 0);
      b.setAttribute('aria-expanded', i === 0 ? 'true' : 'false');
    });

    // por seguridad si IDs no coinciden (muy raro), activamos por data-cat-target
    if (firstBtn && firstPanel && firstPanel.id) {
      activate(firstBtn);
    }
  }

  function openDrawer() {
    if (!isDesktop()) return;

    drawer.hidden = false;

    // opcional: bloquear scroll detrás
    document.documentElement.classList.add('catDrawer-open');
    document.body.classList.add('catDrawer-open');

    if (l1Buttons[0]) activate(l1Buttons[0]);
  }

  function closeDrawer() {
    drawer.hidden = true;

    document.documentElement.classList.remove('catDrawer-open');
    document.body.classList.remove('catDrawer-open');

    setInitialActive();
  }

  // Hover/focus en desktop
  l1Buttons.forEach(btn => {
    btn.addEventListener('mouseenter', () => { if (isDesktop()) activate(btn); });
    btn.addEventListener('focus', () => { if (isDesktop()) activate(btn); });
    btn.addEventListener('click', () => activate(btn)); // por si acaso
  });

  openBtns.forEach(btn => btn.addEventListener('click', openDrawer));
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  // Cerrar al click fuera (overlay)
  drawer.addEventListener('click', (e) => {
    if (e.target === drawer) closeDrawer();
  });

  // ESC
  document.addEventListener('keydown', (e) => {
    if (!drawer.hidden && e.key === 'Escape') closeDrawer();
  });

  // Si pasas de desktop a <1200, cierra
  DESKTOP_MQ.addEventListener('change', () => {
    if (!isDesktop() && !drawer.hidden) closeDrawer();
  });

  // Estado inicial
  closeDrawer();
})();
